<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <el-select class="filter__input" size="mini" v-model="filters.etid" filterable placeholder="请选择">
          <el-option :label="item.title" :value="item.etid" v-for="(item, index) in taskLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">ID：</div>
        <el-input v-model="filters.erqid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">标题：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>

      <div class="filter__item">
        <div class="filter__name">小程序路径：</div>
        <el-input v-model="filters.mina_url" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="ml-auto">
        <button class="blue-small-btn mr-10" @click="initDetail(true)">新建</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="erqid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="etid" label="广告" width="" align="center" sortable>
        <template slot-scope="scope">
          <div>{{scope.row.task_title}}({{scope.row.etid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" width="" align="center">
      </el-table-column>
      <el-table-column prop="mina_url" label="小程序链接" width="" align="center">
      </el-table-column>
      <el-table-column prop="template_id" label="模板ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="url" label="链接" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.url.length <= 45">
            <div slot="reference">{{scope.row.url}}</div>
          </div>
          <el-popover placement="top-end" width="200" trigger="hover" :content="scope.row.url" v-else>
            <div slot="reference">{{scope.row.url.slice(0, 30) + '...'}}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="methods" label="方法" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.methods == 2">GET</div>
          <div v-if="scope.row.methods == 1">POST</div>
        </template>
      </el-table-column>
      <el-table-column prop="headers" label="请求头" width="" align="center">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title=""
            width="400"
            trigger="click">
            <div>{{scope.row.headers}}</div>
            <el-button slot="reference" size="mini">显示</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="body" label="请求数据" width="" align="center">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title=""
            width="400"
            trigger="hover">
            <div>{{scope.row.body}}</div>
            <el-button slot="reference" size="mini">显示</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">运行</div>
          <div v-if="scope.row.status == 0">停止</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn" @click="editDetail(scope.$index)">编辑</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="分类编辑" :visible.sync="detailDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID</div>
            <el-input v-model="detail.erqid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>

          <div class="dataForm__item mt-20">
            <div class="dataForm__name">任务</div>
            <el-select placeholder="请选择" v-model="detail.etid" filterable @change="handleEtidChange" :disabled="detail.erqid !== 0">
              <el-option v-for="item in taskLists" :key="item.value" :label="item.title" :value="item.etid"> </el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">标题</div>
            <el-input v-model="detail.title" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">小程序链接</div>
            <el-input v-model="detail.mina_url" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">模板ID</div>
            <el-input v-model="detail.template_id" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">链接</div>
            <el-input v-model="detail.url" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">方法</div>
            <el-radio-group v-model="detail.methods">
              <div class="dib mr-20">
                <el-radio :label="1">POST</el-radio>
                <el-radio :label="2">GET</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">请求头</div>
            <el-input type="textarea" :rows="8" v-model="detail.headers" placeholder="请求头" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">请求数据:</div>
            <el-input type="textarea" :rows="4" v-model="detail.body" placeholder="请求数据" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="detail.status">
              <div class="dib mr-20">
                <el-radio :label="0">停止</el-radio>
                <el-radio :label="1">运行</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="earnRequestEdit">保存</div>
          <div class="gray-large-btn" @click="detailDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {earnRequestLists, earnRequestEdit, taskLists} from '../../../api/api'
export default {
  name: 'earnRequest',
  mixins: [mixinList],
  data () {
    return {
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '运行',
          value: 1
        },
        {
          name: '停止',
          value: 0
        }
      ],
      lists: [],
      listLoading: false,
      taskLists: [],
      filters: {
        p: 1,
        l: 20,
        total: 0,
        erqid: '',
        etid: '',
        title: '',
        mina_url: '',
        status: ''
      },
      detailDialog: false,
      detail: {
        erqid: 0,
        etid: '',
        title: '',
        mina_url: '',
        template_id: '',
        url: 'https://wx.csjdeveloper.com/pangle/wx_api/cps/generate_carrier_token',
        methods: 1,
        headers: '',
        body: '',
        status: 1
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    handleEtidChange () {
      this.taskLists.forEach((item) => {
        if (item.etid === this.detail.etid) {
          this.detail.title = item.title
          this.detail.mina_url = item.keyword

          let match = item.keyword.match(/weixin:\/\/[^\s]+/)
          if (match) {
            this.detail.mina_url = match[0]
          }
        }
      })
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    initDetail (detailDialog) {
      for (let key in this.detail) {
        this.detail[key] = ''
      }
      this.detail.erqid = 0
      this.detail.methods = 1
      this.detail.status = 1
      this.detail.url = 'https://wx.csjdeveloper.com/pangle/wx_api/cps/generate_carrier_token'

      this.detailDialog = detailDialog
    },
    editDetail (index) {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = this.lists[index][key]
      }
    },
    earnRequestEdit () {
      let params = {
        erqid: this.detail.erqid,
        etid: this.detail.etid,
        title: this.detail.title,
        mina_url: this.detail.mina_url,
        template_id: this.detail.template_id,
        url: this.detail.url,
        methods: this.detail.methods,
        headers: this.detail.headers,
        body: this.detail.body,
        status: this.detail.status
      }

      earnRequestEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.initDetail(false)
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getTaskLists () {
      let params = {
        l: 500,
        p: 1
      }
      taskLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.taskLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.etid + ')',
              etid: item.etid,
              keyword: item.keyword
            }
          })
          this.taskLists.unshift({
            title: '所有',
            etid: ''
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.etid !== '') {
        params.etid = filters.etid
      }

      if (filters.erqid !== '') {
        params.erqid = filters.erqid
      }

      if (filters.title !== '') {
        params.title = filters.title
      }

      if (filters.mina_url !== '') {
        params.mina_url = filters.mina_url
      }

      if (filters.status !== '') {
        params.status = filters.status
      }

      this.listLoading = true
      earnRequestLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    filterParamsChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.etid': 'filterParamsChange',
    'filters.erqid': 'filterParamsChange',
    'filters.title': 'filterParamsChange',
    'filters.mina_url': 'filterParamsChange',
    'filters.status': 'filterParamsChange'
  },
  mounted () {
    this.getList()
    this.getTaskLists()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/earn/earnRequest.vue